import { render } from "./computer.vue?vue&type=template&id=72015afb"
import script from "./computer.vue?vue&type=script&lang=js"
export * from "./computer.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__